// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lds-dual-ring{display:inline-block;height:100px;width:100px}.lds-dual-ring:after{animation:lds-dual-ring 1.2s linear infinite;border-color:#fca532 transparent;border-radius:50%;border-style:solid;border-width:10px;content:\" \";display:block;height:74px;margin:8px;width:74px}@keyframes lds-dual-ring{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
